// Monkey-patch window.fetch → добавляет Authorization: Bearer на все запросы к API.
//
// Зачем: Capacitor iOS WKWebView ITP режет cross-site cookie между
// capacitor://localhost и api.study.iec.exchange — Bearer единственный рабочий
// путь. На web cookie работает параллельно (этот патч безвреден — добавляет
// header только если токен есть и его ещё нет).
//
// Покрывает: tRPC client, Better Auth fetch, SSE streaming, PowerSync pull.
// Вызывается в main.tsx ДО любых API-запросов.
import { getAccessToken } from "./auth-storage";

export function initAuthFetch(): void {
	if (typeof window === "undefined") return;
	const apiBase = import.meta.env.VITE_API_URL ?? "";
	const originalFetch = window.fetch.bind(window);

	window.fetch = (input, init) => {
		const url =
			typeof input === "string"
				? input
				: input instanceof URL
					? input.toString()
					: input instanceof Request
						? input.url
						: "";

		// Запросы к нашему API: либо абсолютный VITE_API_URL (Capacitor),
		// либо same-origin /api/ (web).
		const isApi = apiBase
			? url.startsWith(apiBase)
			: url.startsWith("/api/") || url.includes("/api/");
		if (!isApi) return originalFetch(input, init);

		const token = getAccessToken();
		if (!token) return originalFetch(input, init);

		const headers = new Headers(
			init?.headers ?? (input instanceof Request ? input.headers : undefined),
		);
		if (!headers.has("authorization")) {
			headers.set("authorization", `Bearer ${token}`);
		}
		return originalFetch(input, { ...init, headers });
	};
}
